import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { State, process, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { Import } from 'src/app/models/import';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Utility } from 'src/app/shared/utility';
import { HttpErrorResponse } from '@angular/common/http';
import { IPayrollRecord, PayrollRecord } from 'src/app/models/payrollRecord';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ImportService } from 'src/app/shared/services/payroll/import.service';
import { CommonService } from 'src/app/shared/services/common/common.service';

@Component({
  selector: 'app-payroll-record',
  templateUrl: './payroll-record.component.html',
  styleUrls: ['./payroll-record.component.css']
})
export class PayrollRecordComponent implements OnInit {
  operators: any;
  opened = false;
  submitted = true;
  deleteRecordDialog = false;
  kendoloading = false;
  isErr = false;
  isIssue = false;
  recordIssues: any;
  recordErrors: any;
  Name: string;
  removeRecord: PayrollRecord;
  payrollrecords: PayrollRecord[];
  selectedRecord: IPayrollRecord;
  locations: any[];
  systems: any[];
  editDataItem: any;
  orgId: number;
  isNew: boolean;
  importRecord: Import;
  gridView: GridDataResult;
  filters: CompositeFilterDescriptor;
  msg: string;
  gridData: any[];
  filterValue: any = '';
  globalFilter: boolean;
  totalNoOfRecords = 0;
  skip = 0;
  currentPage = 0;
  gridState: State = {
    group: [],
    sort: [],
    take: 20,
    skip: 0
  };
  gridHeight = {
    height: 'calc(100vh - 170px)'
  };
  validationSettings: any[];
  get import(): Import { return this.importRecord; }
  @Input() set import(selectedImport: Import) {
    this.importRecord = selectedImport;
    this.loadRecords();
    this.loadLocations();
  }
  @Input() set deleteRcdDialog(deleteRecordDialog) {
    if (!deleteRecordDialog) {
      this.deleteRecordDialog = false;
      this.loadRecords();
    }
  }
  @Input() set operations(operators) {
    if (operators) {
      this.operators = operators;
    }
  }
  @Output() onrecordChange = new EventEmitter<boolean>();
  @Output() lastRecordDelete = new EventEmitter<boolean>();
  @Input() set validationSetting(setting) {
    this.validationSettings = setting;
  }

  constructor(
    private importService: ImportService,
    private commonService: CommonService,
    private notificationService: DisplayNotificationService) {
    this.allData = this.allData.bind(this);
  }

  ngOnInit() {
    if (this.import !== undefined) {
      this.loadRecords();
    }
  }

  getGridData(): any {
    return this.payrollrecords.toLocaleString();
  }

  onStateChange(state: State) {
    this.gridState = state;
    this.skip = state.skip === undefined ? 0 : state.skip;
    const me = this;
    this.gridView = process(me.payrollrecords, me.gridState);
  }

  pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    if (this.payrollrecords !== undefined) {
      const records = this.globalFilter ? this.gridData : this.payrollrecords;
      this.gridView = process(records, this.gridState);
    }
  }

  loadRecords(): void {
    if (this.importRecord !== undefined) {
      const id = this.importRecord.id;
      this.globalFilter = false;
      const staging = this.importRecord.submitted === null;
      this.submitted = staging;
      this.importService.getRecords(id, staging)
        .subscribe(payrollrecords => {
          if (payrollrecords && payrollrecords.length > 0) {
            this.filterValue = '';
            if (!staging) { payrollrecords.forEach(value => { value.payPeriodEndDate = new Date(value.payPeriodEndDate); }); }
            this.payrollrecords = payrollrecords;
            this.gridState.skip = 0;
            this.gridView = process(payrollrecords, this.gridState);
            this.totalNoOfRecords = this.payrollrecords.length;
            this.kendoloading = false;
            setTimeout(() => {
              this.currentPage = 1;
              this.notificationService.setUpLoading(false);
            }, 300);
          } else {
            this.notificationService.setUpLoading(false);
          }
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.notificationService.setErrorNotification();
          });
    } else {
      this.submitted = false;
    }
  }

  onInput(inputValue: string): void {
    this.globalFilter = true;
    this.gridData = process(this.payrollrecords, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'name',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'lastFourSSN',
            operator: 'contains',
            value: inputValue,
          }
        ]
      }
    }).data;
    this.gridState.skip = 0;
    this.gridView = process(this.gridData, this.gridState);
  }

  downloadFile() {
    this.importService.generateImportFile(this.import.id.toString())
      .subscribe((data: any) => {
        const fileText = data.message;
        const fileName = this.import.id.toString() + '_SavedPayrollUpload_' + data.datetime + '.txt';
        this.saveTextAsFile(fileText, fileName);
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setErrorNotification();
        });
  }

  saveTextAsFile(data, fileName) {
    if (data) {
      const blob = new Blob([data], { type: 'text/plain' });
      // FOR IE:
      const nav = (window.navigator as any);
      if (nav && nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, fileName);
      } else {
        const e = document.createEvent('MouseEvents');
        const a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        e.initEvent('click', true, false);
        a.dispatchEvent(e);
      }
    }
  }

  closePopup() {
    this.opened = false;
  }

  allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.payrollrecords
    };
    return result;
  }

  loadIssueRecords(issueType: string, id: number, staging: boolean, isError: boolean = false): void {
    if (id !== undefined) {
      this.importService.getIssueRecords(id, issueType, staging, isError)
        .subscribe(response => {
          if (response && response.length > 0) {
            this.filterValue = '';
            this.globalFilter = false;
            this.payrollrecords = response;
            this.gridState.skip = 0;
            this.gridView = process(response, this.gridState);
          } else {
            this.notificationService.setErrorNotification();
          }
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.notificationService.setErrorNotification();
          });
    }
  }

  loadLocations(): void {
    if (this.importRecord !== undefined) {
      this.commonService.getLocations()
        .subscribe(response => {
          if (response && response.locations.length > 0 && response.systems.length > 0) {
          this.locations = response.locations;
          this.systems = response.systems;
          } else {
            this.notificationService.setErrorNotification();
          }
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.notificationService.setErrorNotification();
          });
    }
  }

  openRecord(record: any): void {
    this.recordIssues = [];
    this.recordErrors = [];
    this.Name = record.Name;
    this.selectedRecord = record;
    this.isErr = false;
    this.isIssue = false;
    if (record.isError === 1) {
      this.isErr = true;
      this.recordErrors = record.error.split(',');
    }
    if (record.issue !== '') {
      this.isIssue = true;
      const issues = record.issue.split(',');
      this.recordIssues = Utility.getIssues(issues);
    }
    this.opened = true;
  }

  addHandler() {
    if (this.locations === undefined) {
      this.loadLocations();
    }
    this.editDataItem = new PayrollRecord();
    this.editDataItem.PayrollImportId = this.import.id;
    this.editDataItem.PlanCode = '';
    const ppd = this.importRecord.pped.replace(/-/g, '\/');
    this.editDataItem.PayPeriodEndDate = new Date(ppd);
    this.orgId = this.import.orgId;
    this.isNew = true;
  }

  editHandler(dataItem: PayrollRecord) {
    if (this.locations === undefined) {
      this.loadLocations();
    }
    this.editDataItem = dataItem;
    this.orgId = this.import.orgId;
    this.isNew = false;
  }

  removeHandler(removeEvent: any) {
    this.removeRecord = removeEvent;
    this.deleteRecordDialog = true;
  }

  remove(status: any): void {
    if (status === 'yes') {
      this.kendoloading = true;
      if (this.totalNoOfRecords > 1) {
        this.importService.remove(this.removeRecord)
          .subscribe((response) => {
            if (response && response.success) {
              this.displayResult(response);
            } else {
              this.notificationService.setErrorNotification();
            }
            this.deleteRecordDialog = false;
            this.kendoloading = false;
          },
            (error: HttpErrorResponse) => {
              console.log(error);
              this.kendoloading = false;
              this.deleteRecordDialog = false;
              this.notificationService.setErrorNotification();
            });
      } else {
        this.lastRecordDelete.emit(true);
      }
    } else {
      this.deleteRecordDialog = false;
    }
  }

  displayResult(response: any) {
    let isWarningResp = false;
    let showErrMsg = false;
    const dispResponse = { success: false, message: '' };
    if (response.success || response.status === 200) {
      this.msg = response.message === undefined ? JSON.parse(response._body).message : response.message;
      dispResponse.success = true;
      this.onrecordChange.emit(response.success);
    } else {
      if (response.message === undefined) {
        if (response._body !== '') {
          const errObj = JSON.parse(response._body);
          this.msg = errObj.error;
        } else {
          this.msg = response.statusText;
        }
      } else {
        this.msg = response.message;
        this.onrecordChange.emit(response.success);
      }

      if (response.id) {
        showErrMsg = (response.result.filter(x => x.isError === true).length > 0);
      } else {
        showErrMsg = true;
      }

      if (!showErrMsg) {
        isWarningResp = true;
        this.msg = (this.msg || '').replace('errors/', '');
      } else {
        dispResponse.success = false;
      }
    }
    this.editDataItem = undefined;
    dispResponse.message = this.msg;
    this.notificationService.setUpNotification(dispResponse, isWarningResp);
  }
}
